import { router } from 'expo-router';
import { useCallback } from 'react';

interface UseDiscoverActionsOptions {
  searchQuery: string;
  debouncedQuery: string;
  setIsSearchFocused: (focused: boolean) => void;
}

export function useDiscoverActions({ searchQuery, debouncedQuery, setIsSearchFocused }: UseDiscoverActionsOptions) {
  const handleBusinessPress = useCallback((businessId: string) => {
    router.push({
      pathname: '/(root)/business/[id]',
      params: { id: businessId },
    });
    setIsSearchFocused(false);
  }, [setIsSearchFocused]);

  const handleMoreResultsPress = useCallback(() => {
    router.push({
      pathname: '/(root)/search',
      params: { query: debouncedQuery.trim() },
    });
    setIsSearchFocused(false);
  }, [debouncedQuery, setIsSearchFocused]);

  const handleUserPress = useCallback((identifier: string) => {
    router.push({
      pathname: '/(root)/profile/[username]',
      params: { username: identifier },
    });
    setIsSearchFocused(false);
  }, [setIsSearchFocused]);

  const handleMenuItemPress = useCallback((menuItemId: string) => {
    router.push({
      pathname: '/(root)/menu-item/[id]',
      params: { id: menuItemId },
    });
    setIsSearchFocused(false);
  }, [setIsSearchFocused]);

  const handleTrendingSeeAll = useCallback(() => {
    router.push({ pathname: '/(root)/trending' } as any);
  }, []);

  const handleNearbySeeAll = useCallback(() => {
    router.push({ pathname: '/(root)/nearby' } as any);
  }, []);

  const handleLeaveReview = useCallback(() => {
    router.push({ pathname: '/(tabs)/check-in' } as any);
  }, []);

  const handleSearchSubmit = useCallback(() => {
    const trimmed = searchQuery.trim();
    if (trimmed.length >= 2) {
      router.push({
        pathname: '/(root)/search',
        params: { query: trimmed },
      });
      setIsSearchFocused(false);
    }
  }, [searchQuery, setIsSearchFocused]);

  const handleBackdropPress = useCallback(() => {
    setIsSearchFocused(false);
  }, [setIsSearchFocused]);

  return {
    handleBusinessPress,
    handleMoreResultsPress,
    handleUserPress,
    handleMenuItemPress,
    handleTrendingSeeAll,
    handleNearbySeeAll,
    handleLeaveReview,
    handleSearchSubmit,
    handleBackdropPress,
  };
}
